module.exports = __webpack_public_path__ + "1c80e73b7283242eb26adc56a098e23c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/mobileBanner.jpg
// module id = 1791
// module chunks = 0